import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20Nigerian%20African%20graduates%20celebrating%20success%20university%20degree%20ceremony%20joy%20happiness%20smiling%20Lagos%20Nigeria%20colourful%20academic%20robes%20bright%20sunlight&width=1440&height=600&seq=ngcta1&orientation=landscape"
          alt="Nigerian graduates celebrating"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-teal-900/88" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mx-auto mb-6">
          <i className="ri-rocket-2-line text-white text-3xl" />
        </div>
        <h2 className="text-4xl font-bold text-white mb-4">
          Your Career Transformation Starts Today
        </h2>
        <p className="text-teal-100 text-lg mb-3 leading-relaxed max-w-2xl mx-auto">
          Over 50,000 Nigerians have already transformed their careers and businesses with LearnFlow. From Lagos to Kano, our learners are getting hired, launching startups, and growing their income.
        </p>
        <p className="text-teal-200 text-sm mb-8 font-medium">
          Instructors from Flutterwave, Paystack, Jumia, CcHub & top Nigerian universities
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/signup"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-teal-700 font-bold rounded-xl hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-user-add-line" />
            Create Free Account
          </Link>
          <Link
            to="/courses"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-teal-700 text-white font-semibold rounded-xl hover:bg-teal-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Browse All Courses
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-teal-200 text-sm">
          <span className="flex items-center gap-1.5"><i className="ri-check-line" /> No credit card required</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line" /> Learn at your own pace</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line" /> Certificates included</span>
        </div>
      </div>
    </section>
  );
}
